import { GroupLicense } from '@group/domain';
import { useTranslation } from 'react-i18next';
import { buildDateTimeArgs } from '@framework/i18n/buildDateTimeArgs';

type Props = {
  license: GroupLicense;
};

export const GroupLicenseInfo: React.FC<Props> = ({ license }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="ml-4 border-2 border-slate-300 bg-gray-100 p-2">
      <div className="flex">
        <div className="min-w-32">{t('group.licenseInfo.type')}</div>
        <div>{t(GroupLicense.getTypeLocalStringKey(license.type))}</div>
      </div>
      <div className="flex">
        <div className="min-w-32">{t('group.licenseUsage.licenseCount')}</div>
        <div>{license.count}</div>
      </div>
      {license.type !== 'free' && (
        <div className="flex">
          <div className="min-w-32">{t('group.licenseInfo.expiry')}</div>
          <div>{t('common.dateFormat', buildDateTimeArgs(license.expiresAt))}</div>
        </div>
      )}
    </div>
  );
};
